import num from '@nerdwallet/nw-client-lib/num';

function extractValue({ formattedValue, valueFieldName, mapValue }) {
  if (typeof mapValue === 'function') {
    return mapValue(formattedValue);
  }
  if (valueFieldName === 'value_i' || valueFieldName === 'value_n') {
    return num.value(formattedValue);
  }
  return formattedValue;
}

export default function formatEventValue({
  formattedValue,
  valueFieldName,
  mapValue,
  isValid,
  feedback,
}) {
  const value = extractValue({ formattedValue, valueFieldName, mapValue });

  if (!isValid) {
    return {
      invalid_field_value: `${value}`,
      validation_failure_message: feedback.join(', '),
    };
  }

  return {
    [valueFieldName]: value,
  };
}
